const MenuItems = [{
        name: "Home",
        url: "#home",
        cName: "Nav-links",
    },
    {
        name: "Services",
        url: "#services",
        cName: "Nav-links",
    },
    {
        name: "Destination",
        url: "#destination",
        cName: "Nav-links",
    },
    {
        name: "Furnitures",
        url: "#furniture",
        cName: "Nav-links",
    },
    {
        name: "Contact",
        url: "#footer",
        cName: "Nav-links",
    }
];

export default MenuItems;